import { inToolboxItems } from '../../canvas/tooling/ToolboxController';
import { inTools } from '../../canvas/tooling/ToolManager';
import { Package, PackageHost } from '../../Container';
import { ShapeAutoConfigure } from './ShapeAutoConfigure';
import { shapeTool } from './ShapeTool';
import { shapeToolboxItem } from './ShapeToolboxItem';

export class ShapePackage implements Package {

    public install = (host: PackageHost) => host
        .register(ShapeAutoConfigure, 'singleton', 'startable')
        .plug(inTools(shapeTool))
        .plug(inToolboxItems(shapeToolboxItem))
        ;
}
